<template>
  <div class="footer">
    <div class="foot_top">
      <div class="wrap fixed">
        <div class="foot_ll">
          <ul class="fixed">
            <li v-for="(item, index) in getSiteConfigData?.footerLinkList" :key="index">
              <h3 class="fnt_18 bold">{{ item.linkName }}</h3>
              <p v-for="(itemOne, inx) in item.children" :key="inx"><a :href="itemOne.linkUrl">{{ itemOne.linkName
                  }}</a></p>
            </li>
          </ul>
        </div>
        <div class="foot_rr fixed">
          <dl class="fixed select-box fnt_14" v-if="isWxEnv == false">
            <dt>
              <a href="javascript:void(0);">友情链接</a><i class="icon-xiajiantou"></i>
            </dt>
            <dd>
              <a v-for="(item, index) in getSiteConfigData?.linkList" :key="index" target="_blank"
                :href="item.linkUrl">{{ item.linkName }}</a>
            </dd>
          </dl>

          <div class="share fnt_30">
            <a href="javascriot:void(0)" class="share_wb"><i class="icon-weibo"></i></a>
            <a href="javascriot:void(0)"><i class="icon-weixin"></i>
              <div class="code">
                <img alt="" :src="getSiteConfigData?.commonInfo?.photo3" />
                <p class="fnt_14">{{ getSiteConfigData?.commonInfo?.singleLine7 }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="foot_bot fnt_14">
      <div class="wrap fixed">
        <p class="fb_ll">
          <a class="link" href="/other/sitemap.html">网站地图</a>
          <a class="link" href="/other/law.html">法律声明</a>
          <a class="link" href="/contact/contact.html">联系我们</a>
          <span v-if="getSiteConfigData?.commonInfo?.singleLine1">电话：<a
              :href="'tel:' + getSiteConfigData?.commonInfo?.singleLine1" class="tel_link">{{
                getSiteConfigData?.commonInfo?.singleLine1 }}</a></span>
          <span v-if="getSiteConfigData?.commonInfo?.singleLine2">传真：{{ getSiteConfigData?.commonInfo?.singleLine2
          }}</span>
          <span v-if="getSiteConfigData?.commonInfo?.singleLine3">地址：{{ getSiteConfigData?.commonInfo?.singleLine3
          }}</span>
        </p>
        <p class="fb_rr">
          <span>{{ getSiteConfigData?.commonInfo?.singleLine4 }}</span><em>{{ getSiteConfigData?.commonInfo?.singleLine5
          }}</em><a :href="isWxEnv ? 'javascript:void(0)' : 'https://beian.miit.gov.cn/'"
            :target="isWxEnv ? '_self' : '_blank'">{{ getSiteConfigData?.commonInfo?.singleLine6
            }}</a>
        </p>
      </div>
      <div class="wrap fixed">
        <p class="fb_ll">
          <!-- <a v-for="(item, index) in getSiteConfigData?.businessCertificateList" :key="index" class="link"
            :href="item.linkUrl" target="_blank">{{ item.linkName }}</a> -->
          <a v-for="(item, index) in getSiteConfigData?.businessCertificateList" :key="index" class="link"
            :href="getLinkHref(item)" :target="getLinkTarget(item)">{{ item.linkName }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import axios from "axios";
import $ from 'jquery';
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      getSiteConfigData: null,
      isWxEnv: false,  //是否在微信小程序环境中  false不在   true在
    };
  },
  mounted() {
    search();
    select();
    share();
    this.init();

    // 测试当前环境
    let UA = navigator.userAgent.toLowerCase();
    if (UA.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          //小程序内
          this.isWxEnv = true;
        } else {
          //公众号内
          this.isWxEnv = false;
        }
      })
    } else {
      //都不是 那就只能是移动端h5
      this.isWxEnv = false;
    }

    console.log(this.isWxEnv)

    $(".foot_rr .share a").hover(
      function () {
        $(this).addClass("on");
      },
      function () {
        $(this).removeClass("on");
      },
    );

    $(".toTop").click(function () {
      $("html,body").stop().animate({ scrollTop: 0 });
    });

    //顶部悬浮
    if ($(window).width() > 1024) {
      $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
          $("body").addClass("scroll-header");
        } else {
          $("body").removeClass("scroll-header");
        }
      });
    }

    if ($(window).width() < 767) {
      $(".foot_top li h2").click(function () {
        $(this).parent("li").siblings().removeClass("on");
        $(this).parent("li").siblings().find(".con").slideUp();
        $(this).parent("li").toggleClass("on");
        $(this).parent("li").find(".con").slideToggle();
      });
    }

    //弹出视频
    var srcl = "",
      simg = "";
    $(document).on("click", ".btn_video", function (e) {
      srcl = $(this).data("video");
      simg = $(this).data("img");
      $(".video_appbox").addClass("show");
      video();
    });
    $(document).on("click", ".video_close", function () {
      $(this).parent(".video_appbox").removeClass("show");
      $(".video_t").html("");
    });
    $(document).on("click", ".video_appbox .mask", function () {
      $(this).parent(".video_appbox").removeClass("show");
      $(".video_t").html("");
    });
    function video() {
      $(".video_t").html(
        "<video width='500' height='400' src='" +
        srcl +
        "' type='video/mp4' id='media' poster='" +
        simg +
        "' controls='controls' preload='none' autoplay='autoplay'></video>",
      );

      $(".video_t video").attr({
        width: $(".video_t").width(),
        height: $(".video_t").height(),
      });
    }
    //select
    function select() {
      $(".select-box").each(function (i) {
        $(this)
          .find("dt")
          .click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            var el = $(this).parent(".select-box");
            if (el.hasClass("open")) {
              el.removeClass("open");
              el.find("dd").stop().slideUp();
            } else {
              el.addClass("open");
              el.find("dd").stop().slideDown();
              el.parents("li")
                .siblings("li")
                .find(".select-box")
                .find("dd")
                .stop()
                .slideUp();
              el.parents("li")
                .siblings("li")
                .find(".select-box")
                .removeClass("open");
            }
            $(".CountrySelect .moption").slideUp();
          });

        $(".select-box")
          .eq(i)
          .find("dd a")
          .each(function (x) {
            $(this).click(function () {
              var inde = $(this).index();
              $(this).addClass("active").siblings().removeClass("active");
              var el = $(".select-box.open");
              el.next(".select-hidden").val($(this).attr("data-val"));
              el.find("dt a").html($(this).html());
              el.find("dt a").addClass("active");
              el.find("dd a")
                .eq(inde)
                .addClass("active")
                .siblings()
                .removeClass("active");
              setTimeout(function () {
                el.removeClass("open");
                el.find("dd").stop().slideUp();
              }, 1);
              if (el.next(".select-hidden").val() == "Individual") {
                $(".item-box.Individual").removeClass("hide");
                $(".item-box.Team").addClass("hide");
                $(".item-txt .item-con li.Teamli").addClass("hide");
              }
              if (el.next(".select-hidden").val() == "Team") {
                $(".item-box.Team").removeClass("hide");
                $(".item-box.Individual").addClass("hide");
                $(".item-txt .item-con li.Teamli").removeClass("hide");
              }
            });
          });
      });

      $(document).click(function (e) {
        // 如果点击的是mem区域或导航按钮，不执行关闭操作
        if ($(e.target).closest('.mem').length || $(e.target).closest('.nav_phone_btn').length || $(e.target).closest('.nav').length) {
          return;
        }
        $(".select-box.open").removeClass("open");
        $(".select-box").find("dd").stop().slideUp();
      });
    }

    //搜索
    function search() {
      $(document).on("click", ".ser", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass("on");
        $(".search_wrap").toggleClass("on");
        //$(".f_link dd").stop().slideUp();
      });
      $(document).on("click", ".search_box_text", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      $(document).click(function (e) {
        // 如果点击的是mem区域或导航按钮，不执行关闭操作
        if ($(e.target).closest('.mem').length || $(e.target).closest('.nav_phone_btn').length || $(e.target).closest('.nav').length) {
          return;
        }
        $(".search_wrap").removeClass("on");
        $(".ser").removeClass("on");
      });
    }
    //end

    //分享功能
    function share() {
      $(".share_wb").click(function () {
        var url = $(this).data("txt");
        var url = window.location.href;
        var title = document.title;
        var op =
          "http://service.weibo.com/share/share.php?title=" +
          title +
          "&url=" +
          encodeURIComponent(url) +
          "";
        window.open(op);
      });

      $(".share_wx").attr(
        "data-qrcode",
        "http://www.xinhongru.com/qrcode/qrcode.php?content=" +
        window.location.href,
      );
      //$(".share_wx").attr("data-qrcode", "/qrCode/Index.aspx?url=" + window.location.href);

      $(".share_wx").click(function () {
        //var url = "/qrCode/Index.aspx?url=" + window.location.href;
        var url = $(this).attr("data-qrcode");
        console.log(url);
        var title = "";
        title += "<div class='weixin'>";
        title += "<i class='c'>x</i>";
        title += "<h2>二维码</h2>";
        title +=
          "<div class='img'><img src='" +
          url +
          "' width='100px;' height='100px;'></div>";
        title += "<p>扫一扫</p>";
        title += "</div>";
        $("body").remove(".weixin");
        $("body").append(title);
      });
      $(document).on("click", ".weixin .c", function () {
        $(".weixin").remove();
      });
    }
  },
  methods: {
    async init() {
      // 获取footer站点配置
      try {
        // 等待接口返回全量数据
        const response = await axios.get(`${process.env.VUE_APP_SHOP_API}/get-site-config`);
        this.getSiteConfigData = response.data.data || [];
        console.log(this.getSiteConfigData);
      } catch (error) {
      } finally {
      }
    },

    // 判断链接是否包含 masslinkzl.com
    isMasslinkUrl(url) {
      if (!url) return false;
      return url.includes('masslinkzl.com');
    },

    // 判断是否应该禁用（微信环境 && 不包含 masslinkzl.com）
    shouldDisableLink(item) {
      return this.isWxEnv && !this.isMasslinkUrl(item.linkUrl);
    },

    getLinkHref(item) {
      if (this.shouldDisableLink(item)) {
        return 'javascript:void(0)';
      }
      return item.linkUrl || '#';
    },

    getLinkTarget(item) {
      if (this.shouldDisableLink(item)) {
        return '_self';
      }
      return '_blank';
    },
  },
}
//end
</script>
